var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgNoItems = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 177 122",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#NoItems_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M173.892 55.533a12.739 12.739 0 0 0-7.177-4.859L118.396 38.42a35.264 35.264 0 0 0-14.755-.56l-48.185 8.357a35.423 35.423 0 0 0-19.664 10.546l-.133.146 1.68-8.143-26.36-5.313L.253 95.315c-1.173 5.833 1.748 11.547 6.804 14.257 5.096 3.07 11.873 2.082 16.102-2.376l21.705-22.908.52 19.103c.32 11.654 10.886 20.318 22.372 18.329l45.584-7.903a19.128 19.128 0 0 0 8.951-4.138l15.595 10.999 36.459-47.684c3.802-5.406 3.442-12.495-.427-17.447l-.026-.014Zm-46.518 30.85-6.897-21.118 19.383 4.913-12.473 16.206h-.013ZM68.583 3.47 60.819.615c-5.203-1.909-10.993.774-12.914 5.98a10.08 10.08 0 0 0 .307 7.703c1.134 2.443 3.135 4.299 5.656 5.22l8.031 3.15s.12.027.187.014a.278.278 0 0 0 .16-.067c.093-.08.147-.2.134-.32-.6-4.259-1.188-14.538 6.243-18.182.12-.067.2-.187.2-.334a.329.329 0 0 0-.227-.307h-.013Z",
  fill: "#FF59C1"
}), /*#__PURE__*/React.createElement("path", {
  d: "m60.912 46.483.28 17.941 18.53-19.583 24.026 12.214-5.763-17.007",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m60.912 46.483.28 17.941 18.53-19.583 24.026 12.214-5.763-17.007",
  stroke: "#FF59C1",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m82.523 61.234-3.041-17.515M86.873 55.894a1.828 1.828 0 1 0-.002-3.657 1.828 1.828 0 0 0 .002 3.657Z",
  stroke: "#fff",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m82.232 13.736 7.23-1.254c4.902-.85 9.588 2.443 10.44 7.362.85 4.906-2.44 9.596-7.357 10.448l-7.23 1.253-3.08-17.796-.003-.013Z",
  fill: "#D80073"
}), /*#__PURE__*/React.createElement("path", {
  d: "m72.272 1.95-.014.002c-8.145 1.412-13.603 9.164-12.192 17.315l1.17 6.76c1.412 8.152 9.159 13.614 17.304 12.202l.013-.002c8.145-1.413 13.604-9.165 12.193-17.316l-1.17-6.76C88.163 6 80.415.536 72.271 1.95Z",
  fill: "#fff",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.136 43.733a.915.915 0 0 1-1.067-.761.925.925 0 0 1 .76-1.068c9.072-1.576 15.182-10.24 13.608-19.317a.916.916 0 0 1 .76-1.068.925.925 0 0 1 1.067.761c1.748 10.092-5.03 19.717-15.114 21.466l-.014-.013Z",
  fill: "#D80073"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.79 19.263a5.794 5.794 0 0 1-4.723 6.701c-1.147.2-2.268.04-3.268-.387",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.229 53.454 10.152.051c7.19.037 13.05-5.764 13.085-12.956.037-7.192-5.763-13.051-12.954-13.088L18.36 27.41c-7.19-.037-13.05 5.764-13.085 12.956-.037 7.192 5.763 13.052 12.954 13.088Z",
  fill: "#fff",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.916 30.223 14.674 13.71c-.44-3.605 2.122-6.888 5.723-7.329a3.246 3.246 0 0 1 3.616 2.83l2.481 19.05 5.376-16.42a6.57 6.57 0 0 1 8.298-4.205 3.254 3.254 0 0 1 2.068 4.111l-6.084 18.396",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.916 30.223 14.674 13.71c-.44-3.605 2.122-6.888 5.723-7.329a3.246 3.246 0 0 1 3.616 2.83l2.481 19.05 5.376-16.42a6.57 6.57 0 0 1 8.298-4.205 3.254 3.254 0 0 1 2.068 4.111l-6.084 18.396",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.8 30.15-.387.105a4.793 4.793 0 0 0-3.37 5.88l2.04 7.537a4.789 4.789 0 0 0 5.876 3.372l.386-.105a4.793 4.793 0 0 0 3.37-5.879l-2.04-7.537a4.789 4.789 0 0 0-5.876-3.373Z",
  fill: "#fff",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.222 26.417-.386.105a4.793 4.793 0 0 0-3.37 5.879l2.04 7.537a4.789 4.789 0 0 0 5.876 3.373l.386-.105a4.793 4.793 0 0 0 3.37-5.879l-2.041-7.537a4.789 4.789 0 0 0-5.875-3.373Z",
  fill: "#fff",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31.457 31.838-11.18.094c-1.774 0-3.215 1.415-3.215 3.19a7.176 7.176 0 0 0 7.15 7.222l7.231.04",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31.457 31.838-11.18.094c-1.774 0-3.215 1.415-3.215 3.19a7.176 7.176 0 0 0 7.15 7.222l7.231.04",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m81.913 40.206-6.375 1.105a2.523 2.523 0 0 0 .86 4.972l6.376-1.105a2.523 2.523 0 0 0-.861-4.972Z",
  fill: "#D80073"
}), /*#__PURE__*/React.createElement("path", {
  d: "m36.313 55.667-5.123 25.51",
  stroke: "#fff",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.22 11.787c.094-.413-.093-.907-.093-.907C87.353 3.578 79.75-.748 72.052.587c-1.8.307-3.548.935-5.19 1.856l-2.64 1.482 24.052 8.837a1.446 1.446 0 0 0 1.52-.334c.001 0 .348-.28.428-.627v-.014Z",
  fill: "#FF59C1"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "NoItems_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h177v122H0z"
})))));

export default SvgNoItems;